/**
 * Route for `pricing-page`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PricingPagePage } from "../features/pricing-page/PricingPagePage";

export const pricingPageRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pricing-page",
	component: PricingPagePage,
});

export default pricingPageRoute;
